import { z } from "zod";

import FormEngine, { FormEngineProps } from "@components/FormEngine/FormEngine";

import { regex } from "@utils/zod";

const PasswordResetForm = (props: Partial<FormEngineProps>) => {
  return (
    <FormEngine
      validation={zodValidation}
      data={{
        password: "",
        confirmPassword: "",
      }}
      schema={[
        {
          name: "password",
          label: "Password",
          type: "password",
        },
        {
          name: "confirmPassword",
          label: "Confirm Password",
          type: "password",
        },
      ]}
      {...props}
    />
  );
};

const zodValidation = z
  .object({
    password: regex.password,
    confirmPassword: regex.password,
  })
  .superRefine(({ confirmPassword, password }, ctx) => {
    if (confirmPassword !== password) {
      ctx.addIssue({
        code: "custom",
        message: "The passwords do not match.",
        path: ["confirmPassword"],
      });
    }
  });
export default PasswordResetForm;
